import slideRoom from "./slide-room";
import availabilityRequest from "./availability-request";
import buyoutCalculator from "./buyout-calculator";
// @ts-ignore TS7053
export default {
  "slide-room": slideRoom,
  "availability-request": availabilityRequest,
  "buyout-calculator": buyoutCalculator,
};
